import { NOT_AVAILABLE, skipValidation, sleep } from "../util";
import { indexDBStorage } from "../storage/indexDBStorage";
import {DeviceValidationLogHandler} from "../services/deviceValidationLogHandler";
import {ValidationResponse, ValidationResponseCheck, ValidationSummary} from '@npd-ng/adp-types';
import { useDispatch, useSelector } from "react-redux";
import { createFailureAction, createSetConfirmationModalAction, createSetDeviceReadinessSummary, createSetViewAction } from "shared/state/reducer";
import { IADPState, DeviceReadinessInfo, DeviceValidationChecks, checkStatus, Manifest, ValidationResults, FailureType, ValidationChecks} from "../typings";
import { useDeviceMetricsService } from "./useDeviceMetricsService";
import { DeviceValidationService, getErrorCheckPayload } from "../services/deviceValidationService";
import { useUpdatesService } from "./useUpdatesService";
import { fetchService } from "../services/fetchService";
import { useDedupEffect } from "./useDedupEffect";
const logPrefix = "[ADP Student App][DeviceValdation]";
export function useRootDeviceValidationService(props:{
  healthURI:string,
  deviceMetricsUrl:string,
  dataTransferUrl:string,
  putHeader:any
  }) 
  {
  const dispatch = useDispatch();
  const {postDeviceMetrics} = useDeviceMetricsService();
  const {FetchReleaseManifest} = useUpdatesService();
  const deviceInfo = useSelector((state:{rootState:IADPState})=>state.rootState.deviceReadinessState.deviceVitalsInfo)//electron deviceInfoTestData //
  const systemInfo = useSelector((state:{rootState:IADPState})=>state.rootState.deviceState.systemInfo)//chrome extension
  const {postValidationLogs,constructDeviceValidationDataTransferPayload} = 
  DeviceValidationLogHandler({dataTransferUrl:props.dataTransferUrl,putHeader:props.putHeader})
  const state = useSelector((state:{rootState:IADPState})=>state.rootState)
  const deviceValidation = useSelector((state:{rootState:IADPState})=>state.rootState.appState.configuration?.deviceValidationChecks)
const _postDeviceMetrics= async (failureReasons?: any[])=>{
  const deviceValidationStatus: DeviceReadinessInfo={
    "readinessCheckStartedAt": state.deviceReadinessState.deviceReadinessInfo?.readinessCheckStartedAt || new Date().toISOString(),
    "deviceReadinessCheckPassed": (!failureReasons || failureReasons.length === 0) ? true  : false ,          
    "state": "ReadinessCheckCompleted",
    "failureReason": failureReasons || [],
    "readinessCheckCompletedAt": new Date().toISOString()     
  };
  await postDeviceMetrics(deviceValidationStatus,props.deviceMetricsUrl);
  return;
}
const _postDeviceMetricsInProgress= async ()=>{
  const deviceValidationStatus: DeviceReadinessInfo={
    "readinessCheckStartedAt": new Date().toISOString(),
    "deviceReadinessCheckPassed": false ,          
    "state": "ReadinessCheckInProgress",
    "failureReason":  [],
    "readinessCheckCompletedAt": ""     
  };
  await postDeviceMetrics(deviceValidationStatus,props.deviceMetricsUrl);
    return;
}
 const postAllValidationLogsFromIndexDB= async ()=>{
  const dbInstance = await indexDBStorage.getInstance();
  const keys = await dbInstance.transactions.getAll("adp-device-validation-indexed");
  console.log("postAllValidationLogsFromIndexDB",keys);
  
  await Promise.all(keys.map(async (key:IDBValidKey) => {
    const data = await dbInstance.transactions.get("adp-device-validation-indexed",key as string);
    if(keys?.length > 0  && !state.appState.appLaunchId?.includes(key as string)){
      const fileName = `${key}.device-validation.json`
      let status = undefined as any
      if(data){
        status= await postValidationLogs(
          state,fileName,{logHeader:data.logHeader, payload: data.payload,deviceValidationChecks: data.deviceValidationChecks});
      }
        if(status){
          console.log(`successfully sent ${fileName} from the indexdb store. Deleting record form the indexdb.`)
          dbInstance.transactions.delete("adp-device-validation-indexed",key as string);
        }
    }
    }));
  return;
} 
/* const getSummary = (results:ValidationResponse[]) =>{
  const {logHeader} = constructDeviceValidationDataTransferPayload(state,"");
  const failures = results.find(result => result.isCheckPassed === false && result.type === ValidationResponseCheck.HARD_CHECK);
  const deviceReadinessChecks:ValidationSummary = {
    ...logHeader,
    deviceName: state?.deviceState?.deviceId || NOT_AVAILABLE,
    status: failures ? "Failure" : "Success",
    responses: results,
    readinessCheckStartedAt: "",
    deviceReadinessCheckPassed: false,
    state: "DeviceStarted",
    failureReason: [],
    readinessCheckCompletedAt: ""
  }
  return deviceReadinessChecks;
} */
 const postDeviceValidationLog = async(results:ValidationResponse[])=>{
  if(!state.appState.appLaunchId)return;
  const fileName = `${state.appState.appLaunchId}.device-validation.json`; 
  const {logHeader,payload} = constructDeviceValidationDataTransferPayload(state,fileName);
  if(window.navigator.onLine){
    const response = await postValidationLogs(state,fileName);
    if(!response){
      //if posting failed store in indexDB for later re-posting
      if(state.appState.appLaunchId)indexDBStorage.storeValidationLogs(
        {logHeader:logHeader,payload: payload,deviceValidationChecks:
          {
            ...state.deviceReadinessState.deviceReadinessInfo,
            responses:state.deviceReadinessSummary?.responses,
            status:state?.deviceReadinessSummary?.status,
          }
          },state.appState.appLaunchId);
    };
    //post stored logs af any
    await postAllValidationLogsFromIndexDB();
  }
  else {
    if(state.appState.appLaunchId)indexDBStorage.storeValidationLogs(
      {logHeader:logHeader,payload: payload,
        deviceValidationChecks:
        {
          ...state.deviceReadinessState.deviceReadinessInfo,
          responses:state.deviceReadinessSummary?.responses,
          status:state?.deviceReadinessSummary?.status,
        }
      },state.appState.appLaunchId);
  }
 };

 const  performDeviceValidation= async (validationChecks: DeviceValidationChecks)=>{
  
   const deviceValidationService = DeviceValidationService(validationChecks);
   const npnDeviceValidation = deviceValidationService.npnChecks();
  try{
    _postDeviceMetricsInProgress();
  }
  catch(err){
    console.error("[DeviceMetrics] sending the device metrics failed.")
  }
   const validate = async  ()=>{
    console.log(logPrefix,"Validating checks:",validationChecks);
    let healthResponseParsed:any = undefined;
    const validationResults = new Array<Promise<ValidationResults>>();
    const validationChecksKeys = Object.keys(validationChecks);
    for (const validationName of validationChecksKeys) {
      console.log(validationName);
      switch(validationName){
        case "checkBattery":{
          try{
           validationResults.push(deviceValidationService.performBatteryCheck());
           break;
          }
          catch(err){
            console.error("[DeviceValidation] An error occured trying to get battery status.")
            validationResults.push(getErrorCheckPayload("checkBattery",validationChecks,err))
            break;
          }
        }
        case "checkScreen":{
          try{
            validationResults.push(deviceValidationService.performScreenCheck());
            break;
          }
          catch(err){
            console.error("[DeviceValidation] An error occured trying to get battery status.")
            validationResults.push(getErrorCheckPayload("checkScreen",validationChecks,err))
            break;
          }
        }
        case "checkDevice":{
          try{
            validationResults.push(deviceValidationService.performDeviceCheck(state.deviceState?.systemInfo ?? NOT_AVAILABLE));
            break;
          }
          catch(err){
            console.error("[DeviceValidation] An error occured trying to get battery status.")
            validationResults.push(getErrorCheckPayload("checkDevice",validationChecks,err))
            break;
          }
        }
        case "checkBrowserStorage":{
          try {
            validationResults.push(deviceValidationService.performCheckBrowserStorage())
          }
          catch(e){
            console.error("[DeviceValidation] An error occured trying to get checkBrowserStorage.")
            validationResults.push(getErrorCheckPayload("checkBrowserStorage",validationChecks,e))
          }
         
          break;
        }
        case "checkScreenResolution":{
          try{
            validationResults.push(deviceValidationService.performScreenResolutionCheck(
              "checkScreenResolution", "checkInvalidResolution"));
            break;
          }
          catch(err){
            console.error("[DeviceValidation] An error occured trying to get Screen Resolution.")
            validationResults.push(getErrorCheckPayload("checkScreenResolution",validationChecks,err))
            break;
          }
        }
        case "checkChromeExtension":{
          try{
            validationResults.push(deviceValidationService.performChromeExtensionCheck(state.appState.extensionVersion,
              "checkChromeExtension"));
            break;
          }
          catch(err){
            console.error("[DeviceValidation] An error occured trying to get Chrome extension.")
            validationResults.push(getErrorCheckPayload("checkChromeExtension",validationChecks,err))
            break;
          }
        }
        case "checkOSVersion":{
          try{
             validationResults.push(deviceValidationService.performOSVersionCheck(
               "checkOSVersion"));
            break;
          }
          catch(err){
            console.error("[DeviceValidation] An error occured trying to get Operating System information.")
            validationResults.push(getErrorCheckPayload("checkOSVersion",validationChecks,err))
            break;
          }
        }
        case "checkDuplicateScreen":{
          try{
            validationResults.push(deviceValidationService.performDuplicateScreenCheck(
              "checkDuplicateScreen"));
            break;
          }
          catch(err){
            console.error("[DeviceValidation] An error occured trying to get the screen information.")
            validationResults.push(getErrorCheckPayload("checkDuplicateScreen",validationChecks,err))
            break;
          }
        }
        case "checkTouchDevice":{
          try{
            validationResults.push(deviceValidationService.performTouchDeviceCheck(
              "checkTouchScreen"));
            break;
          }
          catch(err){
            console.error("[DeviceValidation] An error occured trying to get the touchscreen information.")
            validationResults.push(getErrorCheckPayload("checkTouchDevice",validationChecks,err))
            break;
          }
        }
        case "checkCloudServerHealth":{
          try{
            validationResults.push(deviceValidationService.performCheckCloudServerHealth(props.healthURI));
            break;
          }
          catch(err){
            console.error("[DeviceValidation] An error occured trying to get the cloud health information.")
            validationResults.push(getErrorCheckPayload("checkCloudServerHealth",validationChecks,err))
            break;
          }
        }
        case "checkConnection":{
          try{
            validationResults.push(deviceValidationService.performCheckConnection());
            break;
          }
          catch(err){
            console.error("[DeviceValidation] An error occured trying to get the coonnection stattus.")
            validationResults.push(getErrorCheckPayload("checkConnection",validationChecks,err))
            break;
          }
        }
        case "checkVersions":{
          try{
            function getManifest():Promise<Manifest> {
              return new Promise(resolve => {
                const onResponse = (response: Manifest)=>{
                  const manifest: Manifest = response;
                  resolve(manifest)
                  
                }
                FetchReleaseManifest(onResponse)
              });
          }
            const manifest:Manifest = await getManifest();
            const remoteVersion = manifest?.manifest?.product?.version ?? NOT_AVAILABLE;
            const localVersion = state.appState.releaseVersion ?? NOT_AVAILABLE;
            if(remoteVersion === NOT_AVAILABLE || localVersion === NOT_AVAILABLE){
              throw new Error (`An error occured trying to get the version in online mode. ${remoteVersion} ${localVersion}`)
            }
            validationResults.push(deviceValidationService.performCheckVersions(
              remoteVersion,localVersion,
              {
                apdVersion: state.appState.appVersion,
                adcVersion: state.appState.expectedADCVersion,
                sciVersion: state.appState.expectedSCIVersion,
                extensionVersion: state.appState.extensionVersion
              }
              ));
            break;
          }
          catch(err){
            console.error("[DeviceValidation] An error occured trying to get the version in online mode.")
            validationResults.push(getErrorCheckPayload("checkVersions",validationChecks,err))
            break;
          }
        }
        case "checkSystemClock":{
          try{
            validationResults.push(deviceValidationService.performCheckSystemClock(props.healthURI));
            break;
          }
          catch(err){
            console.error("[DeviceValidation] An error occured trying to perform clock check.")
            validationResults.push(getErrorCheckPayload("checkSystemClock",validationChecks,err))
            break;
          }
        }
        case "checkNCSServerHealth":{
          try{
            const healthResponse = await fetchService(props.healthURI);
            const responseJSON = await healthResponse.json();
            healthResponseParsed = responseJSON.data;
            validationResults.push(npnDeviceValidation.checkNCSServerHealth(healthResponseParsed));
            break;
          }
          catch(err){
            console.error("[DeviceValidation] An error occured trying to perform ncs server health check.")
            validationResults.push(getErrorCheckPayload("checkNCSServerHealth",validationChecks,err))
            break;
          }
        }
        case "checkNCSVersions":{
          try{
           const components = {
              apdVersion: state.appState.appVersion,
              adcVersion: state.appState.expectedADCVersion,
              sciVersion: state.appState.expectedSCIVersion,
              extensionVersion: state.appState.extensionVersion
            }
            validationResults.push(npnDeviceValidation.checkNCSVersions(healthResponseParsed,state.appState.releaseVersion || NOT_AVAILABLE,components));
            break;
          }
          catch(err){
            console.error("[DeviceValidation] An error occured trying to perform ncs version check.")
            validationResults.push(getErrorCheckPayload("checkNCSVersions",validationChecks,err))
            break;
          }
        }
        case "checkRouterConnection":{
          try{
            validationResults.push(npnDeviceValidation.checkRouterConnection(healthResponseParsed));
            break;
          }
          catch(err){
            console.error("[DeviceValidation] An error occured trying to perform ncs router connection check.")
            validationResults.push(getErrorCheckPayload("checkRouterConnection",validationChecks,err))
            break;
          }
        }
        case "checkNCSEnv":{
          try{
            validationResults.push(npnDeviceValidation.checkNCSEnv(healthResponseParsed,state.appState.environment || NOT_AVAILABLE));
            break;
          }
          catch(err){
            console.error("[DeviceValidation] An error occured trying to perform ncs env check.")
            validationResults.push(getErrorCheckPayload("checkNCSEnv",validationChecks,err))
            break;
          }
        }
        case "checkNCSSystemClock":{
          try{
            validationResults.push(npnDeviceValidation.checkNCSSystemClock(healthResponseParsed));
            break;
          }
          catch(err){
            console.error("[DeviceValidation] An error occured trying to perform ncs system clock check.")
            validationResults.push(getErrorCheckPayload("checkNCSSystemClock",validationChecks,err))
            break;
          }
        }
          case "checkCPU":{
            try{
            let cpuValue = NOT_AVAILABLE
            const deviceCpuInfo = deviceInfo?.find((info)=>info.name === "checkCPU")?.value
            let parsedInfo = typeof deviceCpuInfo === "string" ? JSON.parse(deviceCpuInfo) : deviceCpuInfo   
            if(parsedInfo && !parsedInfo.error){ 
                cpuValue = parsedInfo
            }
              validationResults.push(deviceValidationService.performCPUCheck(cpuValue));
              break;
            }
            catch(err){
              console.error("[DeviceValidation] An error occured trying to get cpu status.")
              validationResults.push(getErrorCheckPayload("checkCPU",validationChecks,err))
              break;
            }
          }
          case "checkRunningProcesses":{
            let  runningProcessesArray: [] | string = NOT_AVAILABLE
            try{
              const runningProcesses = deviceInfo?.find((info)=>info.name === "checkRunningProcesses")?.value;
              let parsedInfo = typeof runningProcesses === "string" ? JSON.parse(runningProcesses) : runningProcesses
              if(parsedInfo && !parsedInfo.error){
                runningProcessesArray = parsedInfo
              }
              validationResults.push(deviceValidationService.performCheckRunningProcesses(runningProcessesArray));
              break;
            }
            catch(err){
              console.error("[DeviceValidation] An error occured trying to get cpu status.")
              validationResults.push(getErrorCheckPayload("checkRunningProcesses",validationChecks,err))
              break;
            }
          }
          
          case "checkMemory":{
            type memoryType = {
              total: number,
              free: number | number
            } | string
            try{
            let memoryValue : memoryType = NOT_AVAILABLE
            const extensionValue = systemInfo?.find((info: { type: string; })=>info?.type === "memory")
            if(extensionValue){
              memoryValue = {
                total: extensionValue?.info?.capacity ?? NOT_AVAILABLE,
                free: extensionValue?.info?.availableCapacity ?? NOT_AVAILABLE
              }
            }
            const windowsDeviceInfo =  deviceInfo?.find((info)=>info.name === "checkMemory")?.value
            if(windowsDeviceInfo){
              let parsedWindowsInfo = typeof windowsDeviceInfo === "string" ? JSON.parse(windowsDeviceInfo) : windowsDeviceInfo;
              memoryValue = {
                total: parsedWindowsInfo?.total ?? NOT_AVAILABLE,
                free: parsedWindowsInfo?.free ?? NOT_AVAILABLE
              }
              }
              validationResults.push(deviceValidationService.performMemoryCheck(memoryValue,"checkMemory"));
              break;
            }
            catch(err){
              console.error("[DeviceValidation] An error occured trying to get memory status.")
              validationResults.push(getErrorCheckPayload("checkMemory",validationChecks,err))
              break;
            }
          }
          case "checkStorage":{
            try{
              let freeSpace = NOT_AVAILABLE
              const storageInfo = deviceInfo?.find((info)=>info?.name === "checkStorage")?.value
              if(storageInfo){
                const parsedValue = typeof storageInfo == "string" ? JSON.parse(storageInfo) : storageInfo
                if(parsedValue?.FreeSpace) freeSpace = parsedValue
              }
              validationResults.push(deviceValidationService.performStorageCheck(freeSpace,"checkStorage"));
              break;
            }
            catch(err){
              console.error("[DeviceValidation] An error occured trying to get storage status.")
              validationResults.push(getErrorCheckPayload("checkStorage",validationChecks,err))
              break;
            }
          }
          
          
          case "checkProccessor":{
            type proccessorType = {
              Name: string,
              MaxClockSpeed: string | number
            } | string
            try{
            let processorValue:any = NOT_AVAILABLE
            const modelName = systemInfo?.find((info: { type: string; })=>info?.type === "cpu")?.info?.modelName;
            if(modelName){
              const match = modelName?.match(/@ (\d+\.\d+)GHz/);
              processorValue = 
              {
                Name: modelName ?? NOT_AVAILABLE,
                MaxClockSpeed: match &&  match.length > 1 && !isNaN(match[1]) ? parseFloat(match[1]) : NOT_AVAILABLE
              }
            }
            else {
              let modelName =  deviceInfo?.find((info)=>info.name === "checkProccessor")?.value;
              const parsedInfo = typeof modelName == "string"  ? JSON.parse(modelName)  : modelName
                if(parsedInfo  && !parsedInfo.error ){
                 processorValue = {
                  Name: parsedInfo?.Name ?? NOT_AVAILABLE,
                  MaxClockSpeed: !isNaN(parsedInfo.MaxClockSpeed) ? parsedInfo.MaxClockSpeed /1000  : NOT_AVAILABLE
                }
              }
             }
            validationResults.push(deviceValidationService.performProccessorCheck(processorValue,"checkProccessor"));
              break;
            }
            catch(err){
              console.error("[DeviceValidation] An error occured trying to get proccessor status.")
              validationResults.push(getErrorCheckPayload("checkProccessor",validationChecks,err))
              break;
            }
          }
          case "checkHardware":{
            try{
              const checkHardware = deviceInfo?.find((info)=>info.name === "checkHardware")?.value
              const parsedInfo = typeof checkHardware == "string"  ? JSON.parse(checkHardware)  : checkHardware
              validationResults.push(deviceValidationService.performHardwareCheck(
                 parsedInfo && !parsedInfo?.error ? parsedInfo :  NOT_AVAILABLE));
              break;
            }
            catch(err){
              console.error("[DeviceValidation] An error occured trying to get hardware status.")
              validationResults.push(getErrorCheckPayload("checkHardware",validationChecks,err))
              break;
            }
          }
          case "checkBrightness":{
            try{
              const checkBrightness  = deviceInfo?.find((info)=>info.name === "checkBrightness")?.value
              const parsedInfo = typeof checkBrightness == "string"  ? JSON.parse(checkBrightness)  : checkBrightness
              validationResults.push(deviceValidationService.performBrightnessCheck( 
                parsedInfo && !parsedInfo?.error ? parsedInfo :  NOT_AVAILABLE));
              break;
            }
            catch(err){
              console.error("[DeviceValidation] An error occured trying to get brightness status.")
              validationResults.push(getErrorCheckPayload("checkBrightness",validationChecks,err))
              break;
            }
        }
        default:{
          break;
        }
      }
     }
    return validationResults
  }
  return new Promise<boolean>(async (resolve) => {
    const promises = await validate();
    Promise.all(promises).then(async (results)=>{
      console.log("[DeviceValidation] the results of the device validation is: ",results)
      dispatch(createSetDeviceReadinessSummary(results));
      await sleep(1000);
      //await postDeviceValidationLog(results);
      const failedChecks = results.filter(result => !result.isCheckPassed && result.type === ValidationResponseCheck.HARD_CHECK);
      if(failedChecks && failedChecks.length > 0  && !(skipValidation())){
        try{
         await _postDeviceMetrics(failedChecks);
        }
        catch(err){
          console.error("[DeviceMetrics] sending the device metrics failed.")
        }
      const customErrors = failedChecks?.find((check)=>check.actionOnFailure!=="DeviceValidationFailure");  
      const runningProccesesErrors = failedChecks?.find((check)=>check.actionOnFailure==="ProccessCheckError");  
      if(runningProccesesErrors){
        dispatch(createSetViewAction("RunningProccessFailureView"))
      }
      else if(customErrors){
        dispatch(createFailureAction(customErrors.actionOnFailure as FailureType));
      }
      else {
        dispatch(createSetViewAction("DeviceValidationFailureView"))
      }
      resolve(false);
     }
     else {
      try{
       await _postDeviceMetrics();
      }
      catch(err){
        console.error("[DeviceMetrics] sending the device metrics failed.")
      }
      state.sessionState.appAccessedFor === "Assess" ? 
      dispatch(createSetConfirmationModalAction(true)): 
      dispatch(createSetViewAction("DeviceValidationSuccessView"));
      resolve(true);
     }
    })
    })
  }
   useDedupEffect(()=>{
    console.log("state.deviceReadinessState",state.deviceReadinessSummary,state.deviceReadinessState)
    if(state.deviceReadinessSummary?.responses && state.deviceReadinessState.validationState === "Completed"){
      postDeviceValidationLog(state.deviceReadinessSummary?.responses);
    }
   },[state.deviceReadinessSummary,state.deviceReadinessState])  
  
  return {postDeviceValidationLog,performDeviceValidation,postAllValidationLogsFromIndexDB};
}

